export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 8;
export function screenToWorld(point, camera) {
    return {
        x: (point.x - camera.panX) / camera.zoom,
        y: (point.y - camera.panY) / camera.zoom,
    };
}
export function worldToScreen(point, camera) {
    return {
        x: point.x * camera.zoom + camera.panX,
        y: point.y * camera.zoom + camera.panY,
    };
}
export function zoomAtPoint(camera, screenPoint, zoomFactor) {
    const worldPoint = screenToWorld(screenPoint, camera);
    const zoom = Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, camera.zoom * zoomFactor));
    return {
        zoom,
        panX: screenPoint.x - worldPoint.x * zoom,
        panY: screenPoint.y - worldPoint.y * zoom,
    };
}
